import styled from 'styled-components'

export const WrapperPage = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 24px;
  height: 100vh;
`
